import { createAction } from 'redux-actions';

import types from './types';

export default {
    setPageLoadInfo: createAction(types.SET_PAGE_LOAD_INFO),
    collectImpression: createAction(types.COLLECT_IMPRESSION),
    clearImpressions: createAction(types.CLEAR_IMPRESSIONS),
    impressionClick: createAction(types.IMPRESSION_CLICK),
    sendViewEventWaiting: createAction(types.SEND_VIEW_EVENT_WAITING),
    sendTransactionWaiting: createAction(types.SEND_TRANSACTION_WAITING),
    checkoutCartEvents: createAction(types.CHECKOUT_CART_EVENTS),
    checkoutPaymentEvents: createAction(types.CHECKOUT_PAYMENT_EVENTS),
    setCurrentStep: createAction(types.SET_CURRENT_STEP),
    setCheckoutOption: createAction(types.SET_CHECKOUT_OPTION),
    setDeliveryOptionCompleted: createAction(types.SET_DELIVERY_OPTION_COMPLETED),
    setPaymentOptionCompleted: createAction(types.SET_PAYMENT_OPTION_COMPLETED),
    setAdditionalStep: createAction(types.SET_ADDITIONAL_STEP),
    setLoginOption: createAction(types.SET_LOGIN_OPTION),
    setCurrentPage: createAction(types.SET_CURRENT_PAGE),
    setCurrentProductList: createAction(types.SET_CURRENT_PRODUCT_LIST),
    incrementCurrentWrapperCounter: createAction(types.INCREMENT_CURRENT_WRAPPER_COUNTER),
    calculateCurrentWrapperCounter: createAction(types.CALCULATE_CURRENT_WRAPPER_COUNTER),
    setWrapper: createAction(types.SET_WRAPPER),
    resetWrappersByType: createAction(types.RESET_WRAPPERS_BY_TYPE),
    setLocation: createAction(types.SET_LOCATION),
    proceedPageload: createAction(types.PROCEED_PAGELOAD),
    setMinicartPopoverStatus: createAction(types.SET_MINICART_POPOVER_STATUS),
    setAddReviewStartTime: createAction(types.SET_ADD_REVIEW_START_TIME),
    setReviewsImpressionView: createAction(types.SET_REVIEWS_IMPRESSION_VIEW),
    setPageload: createAction(types.SET_PAGELOAD),
    collectStoryImpression: createAction(types.COLLECT_STORY_IMPRESSION),
    storyImpressionClick: createAction(types.STORY_IMPRESSION_CLICK),
    handleCameraError: createAction(types.HANDLE_CAMERA_ERROR),
    handleChooseModifaceMode: createAction(types.HANDLE_CHOOSE_MODIFACE_MODE),
};
